import { render, staticRenderFns } from "./TransportLinkTable.vue?vue&type=template&id=be27ce52&"
import script from "./TransportLinkTable.vue?vue&type=script&lang=js&"
export * from "./TransportLinkTable.vue?vue&type=script&lang=js&"
import style0 from "./TransportLinkTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports